import { Action } from 'redux';
import { ACTION_CREATOR_NAME } from 'helpers';
import { CheckoutActionTypes } from 'store/checkout';

export interface SetShowFinanceApplicationNotValidWarningAction extends Action<CheckoutActionTypes.SET_SHOW_FINANCE_APPLICATION_NOT_VALID_WARNING> {
    shouldShowFinanceApplicationNotValidWarning: boolean;
}

export const setShowFinanceApplicationNotValidWarning: (showFinanceApplicationNotValidWarning: boolean) => SetShowFinanceApplicationNotValidWarningAction = (showFinanceApplicationNotValidWarning: boolean) => ({
    type: CheckoutActionTypes.SET_SHOW_FINANCE_APPLICATION_NOT_VALID_WARNING,
    shouldShowFinanceApplicationNotValidWarning: showFinanceApplicationNotValidWarning
});
setShowFinanceApplicationNotValidWarning[ACTION_CREATOR_NAME] = 'setShowFinanceApplicationNotValidWarning';

export type SetShowFinanceApplicationNotValidWarningFunc = (...args: Parameters<typeof setShowFinanceApplicationNotValidWarning>) => void;